import { style } from 'typestyle'

/* Styles ======================================================================================= */
import { StyleClass } from '../style-class'

/* Types ======================================================================================== */
type ClassNames = {
  /**
   * Base class for table
   */
  base: string
  /**
   * Base class for side floating header
   */
  sideFloatingHeader: string
  sideFloatingHeaderProped: {
    loaded: string
  }
  /**
   * Base class for floating header
   */
  floatingHeader: string
  /**
   * Base class for row
   */
  rowBase: string
}

type ClassProps = object

const getNames: (props: ClassProps, theme: any) => ClassNames = (props, theme) => {
  const base = style({
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    position: 'relative',
    whiteSpace: 'nowrap',
    width: '100%',
    height: '100%',
    $nest: {
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    scrollbarWidth: 'none',
  })

  const sideFloatingHeader = style({
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'absolute',
    transform: 'translateX(-100%)',
    width: '100%',
  })

  const sideFloatingHeaderProped = {
    loaded: style({
      transition: theme.transition.medium,
      transitionProperty: 'all',
    }),
  }

  const floatingHeader = style({
    height: 40,
    position: 'absolute',
    width: '100%',
  })

  const rowBase = style({
    borderBottom: `1px solid ${theme.boxes.border.medium}`,
  })

  return {
    base,
    sideFloatingHeader,
    sideFloatingHeaderProped,
    floatingHeader,
    rowBase,
  }
}

/* Export ======================================================================================= */
export const tableClass = new StyleClass<ClassNames, ClassProps>(getNames)
